import React, { Fragment } from "react";
import PropTypes from "prop-types";
import "../../App.css";
import {
  FilterDropdown,
  NotificationHistoryCard,
  SearchInput,
  Chips,
  CustomTableFooter,
} from "../../components";
import { NotificationHistoryDetail } from "../../modules";
import Skeleton from "@mui/material/Skeleton";
import { ApiService } from "../../utils/ApiService";
import { API_URL, ADMIN_TYPE, NOTIFICATION_ENUM } from "../../utils/Constants";
import { Typography } from "@mui/material";
import { colors } from "../../config/colors";

class NotificationHistory extends React.Component {
  constructor(props) {
    super(props);
    this.adminRole = localStorage.getItem("role");
    this.merchantId = localStorage.getItem("globalMerchantId");
    if (this.adminRole == ADMIN_TYPE.SCHOOLADMIN) {
      this.merchantId = localStorage.getItem("schoolAdminMerchantId");
    }
    this.showToPageCount = 0;
    this.fetchCount = 0;
    this.state = {
      isLoading: true,
      pageSize: 10,
      pageNo: 0,
      pageOffset: 0,
      totalHistoryCount: 0,
      showDetail: null,
      filterValue: "all",
      historyList: [],
      filter: [],
      searchFilter: [],
      searchText: "",
    };
  }

  static propTypes = {
    onShowTabs: PropTypes.func.isRequired,
    onHideTabs: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.onFetchHistory();
  }

  onFetchHistory = async () => {
    try {
      this.setState({ isLoading: true });
      this.fetchCount++;
      let totalCount = 0;
      const appliedFilters = [...this.state.filter, ...this.state.searchFilter];

      const urlCount =
        API_URL.NOTIFICATION_HISTORY_COUNT + "?merchantId=" + this.merchantId;
      const respCount = await ApiService.postRequest(urlCount, {
        filter: appliedFilters,
      });
      if (respCount?.status?.code === "Y") totalCount = respCount.body;
      if (totalCount === 0) {
        this.setState({
          isLoading: false,
          historyList: [],
          totalHistoryCount: totalCount,
        });
        return;
      }

      const diff = totalCount - this.state.pageOffset;
      const limitValue =
        diff > this.state.pageSize ? this.state.pageSize : diff;
      const payload = {
        filter: appliedFilters,
        limit: this.state.pageSize,
        offset: this.state.pageNo,
      };
      const urlHistory =
        API_URL.NOTIFICATION_HISTORY + "?merchantId=" + this.merchantId;
      const resp = await ApiService.postRequest(urlHistory, payload);
      if (resp?.status?.code === "Y" && resp.body) {
        this.showToPageCount = this.state.pageOffset + limitValue;
        this.setState({
          isLoading: false,
          historyList: resp.body,
          totalHistoryCount: totalCount,
        });
      }
    } catch (err) {
      console.error("Error fetching notification history:", err);
    }
  };

  onDetailBack = () => {
    this.setState({ showDetail: null }, this.props.onShowTabs);
  };

  onLeftArrow = () => {
    this.setState(
      {
        pageOffset: this.state.pageOffset - this.state.pageSize,
        pageNo: this.state.pageNo - 1,
      },
      this.onFetchHistory
    );
  };

  onRightArrow = () => {
    this.setState(
      {
        pageOffset: this.state.pageOffset + this.state.pageSize,
        pageNo: this.state.pageNo + 1,
      },
      this.onFetchHistory
    );
  };

  onPageSize = (event) => {
    this.setState({ pageSize: event.target.value }, this.onFetchHistory);
  };

  onHistoryDetailsCard = (item) => {
    this.setState({ showDetail: item }, this.props.onHideTabs);
  };

  onChangeFilter = (event) => {
    let filter = [];
    if (event === "student") {
      filter = [
        {
          filterCriteriaEnum: "IS",
          param: "notificationCategoryEnum",
          value: NOTIFICATION_ENUM.STUDENT,
        },
      ];
    } else if (event === "school") {
      filter = [
        {
          filterCriteriaEnum: "IS",
          param: "notificationCategoryEnum",
          value: NOTIFICATION_ENUM.SCHOOL_CUSTOM,
        },
      ];
    } else if (event === "broadcast") {
      filter = [
        {
          filterCriteriaEnum: "IS",
          param: "notificationCategoryEnum",
          value: NOTIFICATION_ENUM.SCHOOL_BROADCAST,
        },
      ];
    }
    this.setState({ filterValue: event, filter: filter }, this.onFetchHistory);
  };

  onSearch = () => {
    if (this.state.searchText.length === 0) return;
    const newSearchFilter = [
      ...this.state.searchFilter,
      {
        filterCriteriaEnum: "LIKE",
        param: "strMessage",
        value: this.state.searchText,
      },
    ];
    this.setState(
      {
        searchFilter: newSearchFilter,
        searchText: "",
        pageNo: 0,
        pageOffset: 0,
        totalHistoryCount: 0,
      },
      this.onFetchHistory
    );
  };

  onRemoveFilterChip = (label, index) => {
    const newSearchFilter = this.state.searchFilter;
    newSearchFilter.splice(index, 1);
    this.setState({ searchFilter: newSearchFilter }, this.onFetchHistory);
  };

  onClearFilter = () => {
    this.setState({ searchFilter: [] }, this.onFetchHistory);
  };

  renderFilters() {
    if (this.state.isLoading || this.state.searchFilter.length === 0)
      return null;
    return (
      <div className="d-flex flex-row align-items-center justify-content-between px-4">
        <div
          className="d-flex flex-row align-items-center"
          style={{ width: "60%", alignItems: "baseline" }}
        >
          <Typography
            variant="h4"
            sx={{ color: colors.nonActive, marginRight: 2 }}
          >
            Filtered by
          </Typography>

          <div className="d-flex flex-wrap">
            {this.state.searchFilter.map((filter, indx) => (
              <div
                style={{ marginRight: 16, marginBottom: 16 }}
                key={filter.value}
              >
                <Chips
                  index={indx}
                  label={filter.value}
                  onClose={this.onRemoveFilterChip}
                />
              </div>
            ))}
          </div>
        </div>
        <Typography
          variant="h4"
          sx={{ color: colors.primary, cursor: "pointer" }}
          onClick={this.onClearFilter}
        >
          Clear Filters
        </Typography>
      </div>
    );
  }

  renderHeader() {
    return (
      <div className="m-4">
        <div className="d-flex flex-row align-items-center justify-content-between w-100">
          {this.state.isLoading ? (
            <Fragment>
              <Skeleton variant="rect" width={100} height={56} />
              <Skeleton variant="rect" width={100} height={56} />
            </Fragment>
          ) : (
            <Fragment>
              <SearchInput
                id="message"
                label="Search Message"
                style={{ width: "456px" }}
                value={this.state.searchText}
                onClickSearch={this.onSearch}
                onChange={(event) =>
                  this.setState({ searchText: event.target.value })
                }
              />
              <div className="d-flex flex-row align-items-center">
                <FilterDropdown
                  selectedValue={this.state.filterValue}
                  onChange={this.onChangeFilter}
                />
              </div>
            </Fragment>
          )}
        </div>
      </div>
    );
  }

  renderHistoryList() {
    if (this.state.isLoading) {
      return (
        <div className="m-4">
          <Skeleton variant="rect" width={"100%"} height={100} />
          <div style={{ height: 20 }} />
          <Skeleton variant="rect" width={"100%"} height={100} />
          <div style={{ height: 20 }} />
          <Skeleton variant="rect" width={"100%"} height={100} />
          <div style={{ height: 20 }} />
          <Skeleton variant="rect" width={"100%"} height={100} />
        </div>
      );
    }
    if (this.state.historyList.length === 0) {
      return (
        <Typography variant="body1" sx={{ padding: "32px" }}>
          No items to display
        </Typography>
      );
    }
    return (
      <div
        style={{
          borderBottomWidth: 1.5,
          borderBottomColor: colors.background,
          borderBottomStyle: "solid",
        }}
      >
        {this.state.historyList.map((item) => (
          <NotificationHistoryCard
            key={item.id}
            item={item}
            onClick={this.onHistoryDetailsCard}
          />
        ))}
      </div>
    );
  }

  renderFooter() {
    return this.state.isLoading ? (
      <div className="m-4">
        <div className="d-flex flex-row align-items-center justify-content-between w-100">
          <Skeleton variant="rect" width={100} height={56} />
          <Skeleton variant="rect" width={100} height={56} />
        </div>
      </div>
    ) : (
      <CustomTableFooter
        pageNo={this.state.pageNo}
        pageSize={this.state.pageSize}
        onPageSizeChanged={this.onPageSize}
        totalCount={this.state.totalHistoryCount}
        onLeftArrow={this.onLeftArrow}
        onRightArrow={this.onRightArrow}
      />
    );
  }

  renderBody() {
    if (this.state.showDetail) {
      return (
        <NotificationHistoryDetail
          item={this.state.showDetail}
          onBack={this.onDetailBack}
        />
      );
    } else if (
      !this.state.isLoading &&
      this.fetchCount === 1 &&
      this.state.historyList.length === 0
    ) {
      return <Typography variant="body1">No items to display</Typography>;
    } else {
      return (
        <div>
          {this.renderHeader()}
          {this.renderFilters()}
          {this.renderHistoryList()}
          {this.renderFooter()}
        </div>
      );
    }
  }

  render() {
    return <div className="my-4">{this.renderBody()} </div>;
  }
}

export default NotificationHistory;
